module.exports = __webpack_public_path__ + "media/images/lp/lp18-0fa8a42c0d5f2e2b84d3aaa9043de90b.webp";